export const PromotionTypeEnum = Object.freeze({
  PUBLIC: "PUBLIC",
  TARGETED: "TARGETED",
});

export const promotionTypeLabels = Object.freeze({
  [PromotionTypeEnum.PUBLIC]: "Publik",
  [PromotionTypeEnum.TARGETED]: "Tertarget",
});
